import React, { useState } from 'react';
import { Modal } from 'antd';
import EventCreateCard from 'components/EventCreateCard';

import './EventCreateDialog.scss';

const EventCreateDialog = props => {
	const { visible, onCreate, onCancel } = props;
	const [submitting, setSubmitting] = useState(false);

	const handleCreate = event => {
		setSubmitting(false);
		onCreate(event);
	};

	return (
		<Modal
			className="EventCreateDialog"
			open={visible}
			onCancel={onCancel}
			footer={null}
			closable={!submitting}
			maskClosable={!submitting}
			keyboard={!submitting}
		>
			<EventCreateCard
				title="Create a New Event"
				onSubmitStart={() => setSubmitting(true)}
				onCreate={handleCreate}
				onCreateFailed={() => setSubmitting(false)}
			/>
		</Modal>
	);
};

export default EventCreateDialog;
